import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {Component, Inject, OnInit} from '@angular/core';
import {FormControl, Validators, FormGroup, FormBuilder} from '@angular/forms';
import { Apollo } from 'apollo-angular';
import {EditMoConvoypGql } from '../../services/moconvoy.service'
import { NotificationService } from '@app/services/notification.service';

@Component({
  selector: 'app-moconvoy',
  templateUrl: './moconvoy.component.html',
  styleUrls: ['./moconvoy.component.css']
})
export class MoconvoyComponent implements OnInit {

  loading = false;
  public myData: any = [];
  public _moconvoyForm: FormGroup;

  constructor(private _formBuilder: FormBuilder,
  private dialogRef: MatDialogRef<MoconvoyComponent>,
  private _moconvoyService: EditMoConvoypGql,
  private notificationService: NotificationService,
  @Inject(MAT_DIALOG_DATA) public data: any, private apollo: Apollo) { }

  onNoClick(): void {
    this.dialogRef.close();
   }
// licencia: licencia, fechaLiberacion: fechaLiberacion, zarpeNumero: this.zarpeModel.numero
ngOnInit() {

  this._moconvoyForm = this._formBuilder.group({
    numero: [this.data.convoy],
    embarcacion: [ this.data.nic, [Validators.required]],
    fecha: [ this.data.fecha, [Validators.required]],
    fechaLiberacion: [ this.data.fechaLiberacion, [Validators.required]],
    observaciones: [ this.data.convObser, [Validators.required]],
  }, {validator: this.dateLessThan('fecha', 'fechaLiberacion')});
}
  onSubmit() {
    this.myData = this._moconvoyForm.value;
    console.log(this.myData.fechaLiberacion);
    this._moconvoyService
    .mutate({
      fecha: this.myData.fechaLiberacion,
      convoyNumero: this.data.convoy,
      convoyObs: this.myData.observaciones
    })
    .subscribe(({ data }: any) => {
      this.loading = false;
      this.notificationService.showNotification('Muy bien!', 'Cambiado exitósamente.', 'success');
      // this.zarpeModel.estadoZarpe = 'FINALIZADO';

      // location.href = '#/zarpes';
    },
      (error) => {
        this.loading = false;
        console.log(error);
       this.notificationService.showNotification('Ha ocurrido un error', 'No cumple con requerimientos', 'warning');
      }
    )

    this.dialogRef.close();

  }

  dateLessThan(from: string, to: string) {
    return (group: FormGroup): {[key: string]: any} => {
     const f = group.controls[from];
     const t = group.controls[to];
     if (f.value > t.value) {
       return {
         dates: 'Date from should be less than Date to'
       };
     }
     return {};
    }
  }
}
